export default __webpack_public_path__ + "static/media/866.e325b89d.gif";